import data from "../data/python.json";

const pythonQuiz = data.python;


export {pythonQuiz};
